module.exports = __webpack_public_path__ + "static/media/tajweed.e1bbf229.png";